import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import DynamicPriceIcon from '../icons/DynamicPriceIcon'
import { EMobilityWallboxPricesModel } from './models/e-mobility-wallbox-models'

interface WallboxPricesProps {
  isDynamicPrice: boolean
  prices: EMobilityWallboxPricesModel[] | undefined
}

/**
 * Component for displaying prices, both for dynamic and regular prices
 * @param isDynamicPrice - as boolean for conditional rendering of dynamic or regular prices
 * @param priceToDisplay - array of prices to display inside wallbox card as EMobilityWallboxPricesModel or undefined
 * @return JSX element
 */
const WallboxPrices: React.VFC<WallboxPricesProps> = ({ isDynamicPrice, prices }) => {
  const { t } = useCustomTranslation()

  const priceToDisplay = prices
    ? prices.filter(price => new Date(price.from).getTime() <= Date.now()).sort((a, b) => new Date(b.from).getTime() - new Date(a.from).getTime())
    : []
  const price = Intl.NumberFormat(navigator.language, { style: 'currency', currency: 'EUR' }).format(priceToDisplay[0]?.price)

  return isDynamicPrice ? (
    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} gap={2}>
      <DynamicPriceIcon />
      <Typography>
        {!priceToDisplay[0] ? t('emobility.wallbox.editTariffs.noTariffSet') : t('emobility.wallbox.dynamic-price-value', { value: price })}
      </Typography>
    </Stack>
  ) : (
    <Typography>{!priceToDisplay[0] ? t('emobility.wallbox.editTariffs.noTariffSet') : `${price}`}</Typography>
  )
}

export default WallboxPrices
